document.addEventListener("DOMContentLoaded", function () {
  const collapsibles = document.querySelectorAll(".food_pairing-collapsible");
  collapsibles.forEach((collapsible) => {
    const tabHead = collapsible.querySelector(".collapsible__tab-head");
    tabHead.addEventListener("click", function () {
      const chevron = collapsible.querySelector(".size-6");
      const content = collapsible.querySelector(".collapsible__tab-content");
      const title = collapsible.querySelector(".food_pairing-title");

      chevron.classList.toggle("active");
      content.classList.toggle("active");
      title.classList.toggle("active");
    });
  });
});
